import { ProgramLevel } from '@gyym/sdk'

export const levelOptions = [
  { label: '入門', value: ProgramLevel.ENTRY },
  { label: '初級', value: ProgramLevel.BEGINNER },
  { label: '中級', value: ProgramLevel.INTERMEDIATE },
  { label: '上級', value: ProgramLevel.ADVANCED },
]

export const pointOptions = [
  { label: '500pt', value: 500 },
  { label: '1000pt', value: 1000 },
  { label: '1500pt', value: 1500 },
  { label: '2000pt', value: 2000 },
  { label: '2500pt', value: 2500 },
  { label: '3000pt', value: 3000 },
  { label: '3500pt', value: 3500 },
  { label: '4000pt', value: 4000 },
  { label: '4500pt', value: 4500 },
  { label: '5000pt', value: 5000 },
  { label: '5500pt', value: 5500 },
  { label: '6000pt', value: 6000 },
  { label: '6500pt', value: 6500 },
  { label: '7000pt', value: 7000 },
  { label: '7500pt', value: 7500 },
  { label: '8000pt', value: 8000 },
  { label: '8500pt', value: 8500 },
  { label: '9000pt', value: 9000 },
  { label: '9500pt', value: 9500 },
  { label: '10000pt', value: 10000 },
]
